import { render, staticRenderFns } from "./ExternalLinkDetails.vue?vue&type=template&id=1ac56252&"
import script from "./ExternalLinkDetails.vue?vue&type=script&lang=ts&"
export * from "./ExternalLinkDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalLinkDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports